import { Typography, Space, Select, Button, Form, Row, Col, Tooltip } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CalendarOutlined,
  FilterOutlined,
  CaretDownOutlined
} from "@ant-design/icons";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import useWindowSize from "../../../Shared/Utils/windowResizeUtils";
import MenuItem from "antd/es/menu/MenuItem";
import "./CustomToolBar.scss";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { Navigate, useNavigate } from "react-router-dom";

const { Title } = Typography;

const CustomToolBar = (props) => {
   console.log(props,"custom toolbar")
  const windowSize$ = useSharedState();
  const { width } = useWindowSize();
  const [form] = Form.useForm();
  const isMobile = width <= 768;
  const navigate = useNavigate();


  const handleView = (event) => {
    props.updateView(event);
  }

  const clearFieldValues = () => {
     form.resetFields();
  }

  const goToBack = () => {
        props.onNavigate('PREV');
        props.handleNavigate('PREV',props?.date);
      };
    const goToNext = () => {
        props.onNavigate('NEXT');
        props.handleNavigate('NEXT',props?.date);
      };
    
      const goToToday = () => {
        props.onNavigate("TODAY");
        props.handleNavigate('TODAY',props?.date);
        props.onView("month");
      };

      const openFilter = () => {
        props.openFilterDrawer();
      }

      const currentYear = new Date(props?.currentDate?.current).getFullYear() || new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = 2100;

      const handleYearChange = (year) => {
        const newDate = new Date(year, new Date(props.date).getMonth(), 1);
        props.handleNavigate('DATE', newDate);
        props.onView('month');
      };

       const handleMonthChange = (month) => {
        const currentDate = new Date(props?.date); 
        const newDate = new Date(currentDate.getFullYear(), month, 1);
        props.handleNavigate('DATE', newDate);
        props.onView('month');
      };

      /**
   * @param {object} params - POST request payload
   * @param {string} fileName - Name of the file to download
   */
  const downloadCSV = (fileName = "medicaid.csv") => {
    ServiceUtils.getBlobRequest("exportMedicaidExcel").then(
      (response) => {
        if (response.status === 200) {
          // Create blob object
          const blob = new Blob([response.data], {
            type: "text/csv;charset=utf-8;",
          });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.setAttribute("download", "medicaid.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  return (
    <div classNmae="medicaid-toolbar">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          margin: "5px",
        }}
      >
        {/* LEFT SIDE */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <Title
            level={5}
            style={{ margin: "0 10px 0 0", cursor: "pointer" }}
            onClick={goToToday}
          >
            <CalendarOutlined style={{ marginRight: 8 }} />
            Today
          </Title>

          <Space>
            <LeftOutlined
              style={{ fontSize: 16, cursor: "pointer" }}
              onClick={goToBack}
            />
            <RightOutlined
              style={{ fontSize: 16, cursor: "pointer" }}
              onClick={goToNext}
            />
          </Space>

          <span className="rbc-toolbar-label" style={{ marginLeft: 12 }}>
            {/* {props.label} */}
            <Select
              suffixIcon={<CaretDownOutlined style={{ color: "black" }} />}
              onChange={handleMonthChange}
              className="no-border"
              value={new Date(props?.currentDate?.current).getMonth()}
            >
              {Array.from({ length: 12 }).map((_, i) => (
                <MenuItem key={i} value={i}>
                  {new Date(2024, i, 1).toLocaleString("default", {
                    month: "long",
                  })}{" "}
                  {/* Replace with dynamic year if needed */}
                </MenuItem>
              ))}
            </Select>
            <Select
              suffixIcon={<CaretDownOutlined style={{ color: "black" }} />}
              onChange={handleYearChange}
              className="no-border"
              value={currentYear}
            >
              {Array.from({ length: endYear - startYear + 1 }).map((_, i) => (
                <MenuItem key={i} value={startYear + i}>
                  {startYear + i}
                </MenuItem>
              ))}
            </Select>
          </span>

          <div style={{ paddingLeft: "12px" }}>
            <Select
              value={props.view}
              onChange={handleView}
              placeholder="Select View"
              style={{ width: isMobile ? 80 : 120 }}
            >
              <MenuItem value="month">Month</MenuItem>
              <MenuItem value="agenda">Agenda</MenuItem>
            </Select>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div style={{ display: "flex" }}>
          <div style={{ paddingRight: "7px" }}>
            <Tooltip title={"Click to apply the filters"}>
              <Button
                onClick={() => {
                  openFilter();
                }}
                style={{ fontWeight: "500" }}
                className="btn-border"
              >
                <Space>
                  <FilterOutlined />
                  {!isMobile && "Filter"}
                </Space>
              </Button>
            </Tooltip>
          </div>
          <div style={{ paddingRight: "7px" }}>
            <Button type="primary" onClick={downloadCSV}>
              Dowload Calendar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomToolBar;
